import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import ListItem from '@mui/material/ListItem';

export const ModalBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(4),
  outline: 'none',
  overflowY: 'auto'
}));

export const CloseIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(2),
  top: theme.spacing(2),
  cursor: 'pointer'
}));

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(2),
  alignItems: 'flex-start'
}));

export const HeaderTitle = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));

export const SearchField = styled(TextField)(({ theme }) => ({
  margin: `${theme.spacing(2)} 0`,
  width: '100%'
}));

export const DeviceListItem = styled(ListItem)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
  marginBottom: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}));

export const DeviceIcon = styled('span')({
  marginRight: '15px'
});

export const ListHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(1),
  backgroundColor: theme.palette.background.default
}));
